import { render, staticRenderFns } from "./secondary-button.vue?vue&type=template&id=32ce45f4&scoped=true"
import script from "./secondary-button.vue?vue&type=script&lang=js"
export * from "./secondary-button.vue?vue&type=script&lang=js"
import style0 from "./secondary-button.vue?vue&type=style&index=0&id=32ce45f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32ce45f4",
  null
  
)

export default component.exports